var map = {
	"./Navigation.vue": 142,
	"./Slider.vue": 143,
	"./navigations/navidation-mobile.vue": 31,
	"./navigations/navigation-desctop.vue": 32,
	"./selectList.vue": 144,
	"./slickSlider.vue": 145,
	"./sliders/_detailPhoto2.vue": 146,
	"./sliders/catalogVueslider.vue": 33,
	"./sliders/default.vue": 34,
	"./sliders/detailPhoto.vue": 35,
	"./sliders/lastProject.vue": 36,
	"./sliders/lowCost2.vue": 37,
	"./sliders/main-slider-v2.vue": 147,
	"./sliders/mainSlider.vue": 38,
	"./sliders/otherStock.vue": 39,
	"./sliders/slider-otherNews.vue": 40,
	"./sliders/slider-photo2.vue": 41,
	"./sliders/stock-product.vue": 148,
	"./sliders/swimSlider.vue": 42
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170;


//////////////////
// WEBPACK FOOTER
// ./src/includes/components ^\.\/.*\.vue$
// module id = 170
// module chunks = 25